import { Modal } from "antd";
import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Layout,
  Button,
  Row,
  Form,
  Input,
  Col,
  Select,
  Collapse,
  theme,
} from "antd";
import { useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import TenantsApi from "../../common/Apis/TenantApi";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import {
  MinusCircleTwoTone,
  PlusCircleTwoTone,
} from "@ant-design/icons";

const { Panel } = Collapse;

const TenantAuditTrail = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const [Tenants, setTenants] = React.useState([]);
  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [formPaginate] = Form.useForm();
  const { useToken } = theme;
  const { token } = useToken();
  const [roleCode, setRoleCode] = useState("");
  const param = new URLSearchParams(window.location.search);
  const tenantId = param.get("id");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const formRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const [filterTenant, setFilterTenants] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  // Load user roles
  useEffect(() => {
    const userDetailsString = localStorage.getItem("decodedToken");
    if (userDetailsString) {
      const userDetails = JSON.parse(userDetailsString);
      const firstRoleDTO = userDetails.roles && userDetails.roles[0];
      if (firstRoleDTO) {
        setRoleCode(firstRoleDTO);
      }
    }
  }, []);

  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });

  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    TenantsApi.tenantsList(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setTenants(response.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1;
    TenantsApi.tenantsList(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew);
        settotalPages(response.totalPages);
        setTenants(response.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // ✅ Correct API payload handling
  const getTenants = useCallback(() => {
    TenantsApi.auditTrail(PaginatePage, PaginateLimit, tenantId)
      .then((response) => {
        settotalPages(response.totalPages);
        setTenants(response.payload); // ✅ fix payload
      })
      .catch((err) => {
        console.log(err);
      });
  }, [PaginatePage, PaginateLimit, tenantId]);

  useEffect(() => {
    getTenants();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, [getTenants]);

  const handleRemovefilterTenant = (FilterTenantIndex) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant.splice(FilterTenantIndex, 1);
    setFilterTenants(newfilterTenant);
    if (FilterTenantIndex === 0) {
      getTenants();
    }
  };

  const handleClear = () => {
    getTenants();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterTenants([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleAddfilterTenants = () => {
    setFilterTenants([
      ...filterTenant,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterTenant
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=BETWEEN${createDateTimestamp(
            obj.answerType
          )}AND${createDateTimestamp(obj.name)}`;
        }
      })
      .join("&");

    let filderData = window.btoa("componentCode=TENANT&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
);
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setTenants(response.payload);
      })
      .catch((err) => {});
  };

  const createDateTimestamp = (Cdate) => {
    const date = new Date(Cdate);
    const unixTime = Math.floor(date.getTime());
    return unixTime;
  };

  const handleChangeTitle = (filterTenantIndex, value) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant[filterTenantIndex].title = value;
    setFilterTenants(newfilterTenant);
  };
  const handleChangeAnswertype = (filterTenantIndex, value) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant[filterTenantIndex].answerType = value;
    setFilterTenants(newfilterTenant);
  };
  const handleChangename = (filterTenantIndex, value) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant[filterTenantIndex].name = value;
    setFilterTenants(newfilterTenant);
  };

  
  const renderTableRows = () => {
    return Tenants.map((item) => (
      <tr key={item.id + item.revisionDate} className="text-center">
        <td>{item.paymentStatus}</td>
        <td>{item.modifiedBy}</td>
        <td>{new Date(item.revisionDate).toLocaleString()}</td>
        <td>{new Date(item.statusStartDate).toLocaleDateString()} - {new Date(item.statusEndDate).toLocaleDateString()}</td>
        <td className="text-center">{item.changeType}</td>
      </tr>
    ));
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />

      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}

        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              {/* <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterTenant.map((input, filterTenantIndex) => (
                    <div key={filterTenantIndex}>
                      <Row gutter={12}>
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterTenantIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterTenantIndex, value)
                              }
                              options={[
                                { value: "tenantCode", label: "Code" },
                                {
                                  value: "tenantName",
                                  label: "Name",
                                },
                                {
                                  value: "createdDate",
                                  label: "Registered Date",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          {filterTenant[filterTenantIndex].title ===
                          "createdDate" ? (
                            <>
                              <Form.Item
                                name={`nameto${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Start Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  onChange={(e) =>
                                    handleChangeAnswertype(
                                      filterTenantIndex,
                                      e.target.value
                                    )
                                  }
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`type${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select mb-1"
                                  placeholder="Condition"
                                  onChange={(value) =>
                                    handleChangeAnswertype(
                                      filterTenantIndex,
                                      value
                                    )
                                  }
                                  options={[
                                    { value: "%", label: "Matches with" },
                                    {
                                      value: "=",
                                      label: "Equals to",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>
                        <Col span={5}>
                          {filterTenant[filterTenantIndex].title ===
                          "createdDate" ? (
                            <>
                              <Form.Item
                                name={`name${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select End Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterTenantIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`name${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Text.",
                                  },
                                ]}
                              >
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterTenantIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterTenantIndex === 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterTenants}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterTenant(filterTenantIndex)
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse> */}
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div></div>
              <div>
                <Form form={formPaginate}>
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: "100px" }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value);
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>
              </div>
            </div>
            <table className="table Tenants-table">
              <thead>
                <tr>
                  <th>Payment Status</th>
                  <th>Modified By</th>
                  <th>Revision Date</th>
                  <th>Billing Period</th>
                  <th className="text-center">Change Type</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
          </div>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default TenantAuditTrail;
